import React, { useCallback, useMemo } from "react";
import { UncontrolledTooltip } from "reactstrap";
import cx from "classnames";

import { Button, SPINNER_SIZES } from "components";
import { SmallControlledNumberInput } from "components/Inputs/SmallControlledNumberInput";
import * as Scrivito from "scrivito";
import { useTranslate } from "hooks";

import {
  useIsFormDirty,
  useIsFetching,
  useMaximumQuestionnairesCount,
  useQuestionnaireLists,
  useWizardActions,
  useIsDuplicationQuestionnaireFetching,
  useSubType,
} from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";

export const DuplicateButton = Scrivito.connect(
  ({ isFieldsConstraintViolated }) => {
    const translate = useTranslate();
    const [duplicateCount, setDuplicateCount] = React.useState(1);

    const { duplicateWizardStepQuestionnaire } = useWizardActions();
    const isSomethingFetching = useIsFetching();
    const isDuplicationZoneFetching = useIsDuplicationQuestionnaireFetching();
    const isFormDirty = useIsFormDirty();
    const maxQuestionnaireCount = useMaximumQuestionnairesCount();
    const questionnaireLists = useQuestionnaireLists();
    const handleDuplicateQuestionnaire = useCallback(() => {
      duplicateWizardStepQuestionnaire({
        duplicationFactor: duplicateCount,
      }).finally(() => {
        setDuplicateCount(1);
      });
    }, [duplicateCount, duplicateWizardStepQuestionnaire]);
    const subType = useSubType();

    // TODO: Temporary disabled for Wireless Wizard due 66045
    const isDuplicateDisabled = useMemo(
      () =>
        isFieldsConstraintViolated ||
        isSomethingFetching ||
        isDuplicationZoneFetching ||
        isFormDirty ||
        subType === "roomcontrolwireless",
      [
        isFieldsConstraintViolated,
        isSomethingFetching,
        isDuplicationZoneFetching,
        isFormDirty,
        subType,
      ],
    );

    const handleDuplicateValueChange = useCallback((val) => {
      setDuplicateCount(val);
    }, []);

    return (
      <div
        className={cx("position-relative", {
          "d-none": questionnaireLists.length === maxQuestionnaireCount,
          "border-end": questionnaireLists.length !== 1,
        })}
      >
        <Button
          data-testid="WizardQuestionnaireTitleIcons_duplicate-btn"
          className="px-3 py-0 lh-0 shadow-none me-1 bg-transparent border-0"
          color="transparent"
          icon="duplicate-light"
          iconClassName="icon-20"
          iconPrefix="trox"
          id="wizard_top_duplicate_icon"
          onClick={handleDuplicateQuestionnaire}
          disabled={isDuplicateDisabled}
          isLoading={isDuplicationZoneFetching}
          spinnerSize={SPINNER_SIZES.XXS}
        />
        <UncontrolledTooltip target="wizard_top_duplicate_icon" placement="top">
          {translate("DUPLICATE")}
        </UncontrolledTooltip>
        <div className="position-absolute mt-1">
          <SmallControlledNumberInput
            value={duplicateCount}
            onChange={handleDuplicateValueChange}
            min={1}
            max={maxQuestionnaireCount - questionnaireLists.length}
            disabled={isDuplicateDisabled}
          />
        </div>
      </div>
    );
  },
);
